import React, { useState } from 'react';

const Products = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [ingredSearch, setingredSearch] = useState('');
  const [oilSearch, setOilSearch] = useState('');
  const [extractSearch, setExtractSearch] = useState('');
  const [pulseSearch,setPulseSearch]=useState('');
  const [activeCategory, setActiveCategory] = useState('all');

 const herbsData = [
    { herb1: "Apium Graveoens", botanical1: "AOHnite Ferox", herb2: "Agar", botanical2: "Aquillaria gallocha" },
    { herb1: "Ageda", botanical1: "Achyranthes aspera", herb2: "Ajmod", botanical2: "Apium graveoens" },
    { herb1: "Ajowan seeds", botanical1: "Ajowan seeds", herb2: "Akkalkara mul", botanical2: "Anacylus pyrethrum" },
    { herb1: "Aloes", botanical1: "Aloes indica", herb2: "Amba chhal", botanical2: "Mangifera indica" },
    { herb1: "Ambahalder", botanical1: "Cucurma amda", herb2: "Amla", botanical2: "Emblica officinalis" },
    { herb1: "Amli", botanical1: "Tamarindus indicus", herb2: "Anantmool", botanical2: "Hemidesmus indicus" },
    { herb1: "Ankdo", botanical1: "Calotropis giganta", herb2: "Annatto seeds", botanical2: "Baxa orellana" },
    { herb1: "Anuir", botanical1: "Ficus carica", herb2: "Apple", botanical2: "Pyrus malus" },
    { herb1: "Aritha", botanical1: "Sapindus trifoliatus", herb2: "Arjun bark", botanical2: "Terminalia arjuna" },
    { herb1: "Arni mool root", botanical1: "Clitoria ternatea", herb2: "Ashok bark", botanical2: "Saraca indica" },
    { herb1: "Shwagandha", botanical1: "Withania somnifera", herb2: "Atibala-chikana", botanical2: "Sida cordifolia" },
    { herb1: "Ativish", botanical1: "Aconitum heterophyllum", herb2: "Babul bark", botanical2: "Acacia arabica" },
    { herb1: "Babul pods", botanical1: "Acacia arabica", herb2: "Baheda", botanical2: "Terminalia belerica" },
    { herb1: "Bakayan(fruit)", botanical1: "Melia azedarach", herb2: "Banafshah, wild violet", botanical2: "Viola odorata" },
    { herb1: "Baru mool", botanical1: "Andropogon halepensis", herb2: "Babchi seeds", botanical2: "Psoralea" },
    { herb1: "Beal fruit", botanical1: "Aegle marmelos", herb2: "Beal mul", botanical2: "Aegle marmelos" },
    { herb1: "Bealphal", botanical1: "Aegle marmelos", herb2: "Belladona leaf/herb", botanical2: "Atropa belladonna" },
    { herb1: "Belladona root", botanical1: "Atropa belladonna", herb2: "Bhava", botanical2: "Vassia fistula fruit" },
    { herb1: "Bharangi mool", botanical1: "Clerodendrum indicum", herb2: "Bhillama, bhella", botanical2: "Semecarpus anacardium" },
    { herb1: "Bhui kokhala", botanical1: "Kantakari", herb2: "Bhoi-pathri", botanical2: "Launaea pinnatifida" },
    { herb1: "Bidhara", botanical1: "Argyreia speciosa", herb2: "Bijasar", botanical2: "Pterocarpus marsupium" },
    { herb1: "Bhui-amla", botanical1: "Phyllanthus niruri", herb2: "Black piper", botanical2: "Piper nigrum" },
    { herb1: "Blackteal", botanical1: "Sesamum indicum", herb2: "Chavak", botanical2: "Piper chaba" },
    { herb1: "Chitrak mool", botanical1: "Plumbago rosea", herb2: "Chopchini", botanical2: "Smilax china" },
    { herb1: "Cinchona officinale", botanical1: "Cinchona officinale", herb2: "Curry leaf", botanical2: "Bergera koenigis" },
    { herb1: "Dalchini", botanical1: "Eragrostis", herb2: "Darbha", botanical2: "Cynosuroide" },
    { herb1: "Daruhalder", botanical1: "Berberis aristata", herb2: "Dashmool", botanical2: "Dashmool" },
    { herb1: "Devdhar", botanical1: "Cedrus deodara", herb2: "Dikemari", botanical2: "Gardenis gummifera" },
    { herb1: "Dhamasa", botanical1: "Fagonia arabica", herb2: "Dhayati", botanical2: "Woodfordia fruticosa" },
    { herb1: "Dhana", botanical1: "", herb2: "Dhatura folio", botanical2: "Dhatura alba" },
    { herb1: "Dhatura phool", botanical1: "Woodfordia horbundas", herb2: "Dudal", botanical2: "Taraxacum officinale" },
    { herb1: "Dudhi", botanical1: "Euphorbia thymifolia", herb2: "Elaichi", botanical2: "Elattaria cardamomum" },
    { herb1: "Ephedra", botanical1: "Ephedra vulgaris", herb2: "Eranda root", botanical2: "Ricinus communis" },
    { herb1: "Euphorbia", botanical1: "Euphorbia hirta", herb2: "Gahula", botanical2: "Prunus mahaleb" },
    { herb1: "Gandhprasarini leaf", botanical1: "Paederia foetida", herb2: "Garlic, lashun", botanical2: "Allium sativum" },
    { herb1: "Garmola, amaltas", botanical1: "Cassia fistula", herb2: "Ginger, lashun", botanical2: "Zingiber officinale" },
    { herb1: "Glycyrrhiza, mulethi", botanical1: "Glycyrrhiza glabra", herb2: "Godambi", botanical2: "Semecarpus anacardium" },
    { herb1: "Gokhru", botanical1: "Tribulus terrestris", herb2: "Gorakhmundi", botanical2: "Sphaeranthus indicus" },
    { herb1: "Green chilli", botanical1: "Capsicum annum", herb2: "Guduchi, galo, amruta", botanical2: "Tinospora cordifolia" },
    { herb1: "Guggal", botanical1: "", herb2: "Guggal ethyl acetate", botanical2: "" },
    { herb1: "Gurmar", botanical1: "Gymnema sylvestre", herb2: "Halder", botanical2: "Curcuma longa" },
    { herb1: "Harde, harir, haritaki", botanical1: "Terminalia chebula", herb2: "Henna leaf", botanical2: "Lawsonia alba" },
    { herb1: "Hing", botanical1: "Ferula assafoetida", herb2: "Indrajav", botanical2: "Wrightia tinctoria" },
    // And so on...
  ];

 const oils = [
    // Essential Oils
    { name: "Ajowain Oil", type: "Essential Oil" },
    { name: "Anise Oil", type: "Essential Oil" },
    { name: "Amyris Oil", type: "Essential Oil" },
    { name: "Astrofolia Oil", type: "Essential Oil" },
    { name: "Basil Oil", type: "Essential Oil" },
    { name: "Betel Leaf Oil", type: "Essential Oil" },
    { name: "Betel Nut Oil", type: "Essential Oil" },
    { name: "Blue Chamomile Oil", type: "Essential Oil" },
    { name: "Cade Oil", type: "Essential Oil" },
    { name: "Cajeput Oil", type: "Essential Oil" },
    { name: "Calamus Oil", type: "Essential Oil" },
    { name: "Caraway Oil", type: "Essential Oil" },
    { name: "Carrot Seed Oil", type: "Essential Oil" },
    { name: "Cassia Oil", type: "Essential Oil" },
    { name: "Cedarwood Oil", type: "Essential Oil" },
    { name: "Celery Seed Oil", type: "Essential Oil" },
    { name: "Cinnamon Bark Oil", type: "Essential Oil" },
    { name: "Cinnamon Leaf Oil", type: "Essential Oil" },
    { name: "Clove Bud Oil", type: "Essential Oil" },
    { name: "Clove Leaf Oil", type: "Essential Oil" },
    { name: "Cumin Oil", type: "Essential Oil" },
    { name: "Curry Leaf Oil", type: "Essential Oil" },
    { name: "Cyperiol Oil (nagarmotha)", type: "Essential Oil" },
    { name: "Chamomile Oil", type: "Essential Oil" },
    { name: "Davana Oil", type: "Essential Oil" },
    { name: "Dill Seed Oil", type: "Essential Oil" },
    { name: "Elemi Oil", type: "Essential Oil" },
    { name: "Eucalyptus Citrodora Oil", type: "Essential Oil" },
    { name: "Eucalyptus Oil (Nilgiri)", type: "Essential Oil" },
    { name: "Fennel Oil", type: "Essential Oil" },
    { name: "Bitter Fennel Oil", type: "Essential Oil" },
    { name: "Sweet Fenugreek Oil", type: "Essential Oil" },
    { name: "Frankincense Oil", type: "Essential Oil" },
    { name: "Geranium Oil", type: "Essential Oil" },
    { name: "Ginger Lily Oil", type: "Essential Oil" },
    { name: "Grape Fruit Oil", type: "Essential Oil" },
    { name: "Holy Basil Oil", type: "Essential Oil" },
    { name: "Jasmine Oil", type: "Essential Oil" },
    { name: "Jatamansi Oil", type: "Essential Oil" },
    { name: "Jyotismati Oil", type: "Essential Oil" },
    { name: "Juniper Berry Oil", type: "Essential Oil" },
    { name: "Kapoor Kachrai Oil", type: "Essential Oil" },
    { name: "Laurel Leaf Oil", type: "Essential Oil" },
    { name: "Lemon Balm (Melissa) Oil", type: "Essential Oil" },
    { name: "Lemon Grass Oil", type: "Essential Oil" },
    { name: "Lime Oil", type: "Essential Oil" },
    { name: "Mandarin Oil", type: "Essential Oil" },
    { name: "Malkangani Oil", type: "Essential Oil" },
    { name: "Marjoram Oil", type: "Essential Oil" },
    { name: "Melissa Oil", type: "Essential Oil" },
    { name: "Myrrh Oil", type: "Essential Oil" },
    { name: "Myrtle Oil", type: "Essential Oil" },
    { name: "Neroli Oil", type: "Essential Oil" },
    { name: "Niaouli Oil", type: "Essential Oil" },
    { name: "Olibanum Oil", type: "Essential Oil" },
    { name: "Orange Oil", type: "Essential Oil" },
    { name: "Bitter Orange Oil", type: "Essential Oil" },
    { name: "Sweet Oregano Oil", type: "Essential Oil" },
    { name: "Palmarosa Oil", type: "Essential Oil" },
    { name: "Parsley Seed Oil", type: "Essential Oil" },
    { name: "Patchouli Oil", type: "Essential Oil" },
    { name: "Peru Balsam Oil", type: "Essential Oil" },
    { name: "Petit Grain Oil", type: "Essential Oil" },
    { name: "Rose Geranium Oil", type: "Essential Oil" },
    { name: "Rose Oil", type: "Essential Oil" },
    { name: "Rosemary Oil", type: "Essential Oil" },
    { name: "Spikenard Oil (jatmansi)", type: "Essential Oil" },
    { name: "Star Anise Oil", type: "Essential Oil" },
    { name: "Sugandh Kokila Oil", type: "Essential Oil" },
    { name: "Sugandhmantri Oil", type: "Essential Oil" },
    { name: "Tea Tree Oil", type: "Essential Oil" },
    { name: "Turmeric Root Oil", type: "Essential Oil" },
    { name: "Tegetus Oil", type: "Essential Oil" },
    { name: "Thyme Oil", type: "Essential Oil" },
    { name: "Tolu Balsam Oil", type: "Essential Oil" },
    { name: "Turmeric Oil", type: "Essential Oil" },
    { name: "Valerian Root Oil", type: "Essential Oil" },
    { name: "Vanilla Oil", type: "Essential Oil" },
    { name: "Verbena Oil", type: "Essential Oil" },
    { name: "Amla Oil", type: "Carrier Oil" },
    { name: "Almond Oil", type: "Carrier Oil" },
    { name: "Aloe Vera Oil", type: "Carrier Oil" },
    { name: "Apricot Oil", type: "Carrier Oil" },
    { name: "Arachis Oil", type: "Carrier Oil" },
    { name: "Argan Oil", type: "Carrier Oil" },
    { name: "Avocado Oil", type: "Carrier Oil" },
    { name: "Ashwagandha Oil", type: "Carrier Oil" },
    { name: "Bhringraj Oil", type: "Carrier Oil" },
    { name: "Brahmi Oil", type: "Carrier Oil" },
    { name: "Black Seed Oil", type: "Carrier Oil" },
    { name: "Borage Seed Oil", type: "Carrier Oil" },
    { name: "Calendula Oil", type: "Carrier Oil" },
    { name: "Castor Oil", type: "Carrier Oil" },
    { name: "Cashew Nut Oil", type: "Carrier Oil" },
    { name: "Coconut Oil", type: "Carrier Oil" },
    { name: "Ginger Grass Oil", type: "Carrier Oil" },
    { name: "Jasmine Absolute", type: "Carrier Oil" },
    { name: "Lavender Oil", type: "Carrier Oil" },
    { name: "Lemon Grass Oil", type: "Carrier Oil" },
    { name: "Mimosa Absolute", type: "Carrier Oil" },
    { name: "Myrtle Oil", type: "Carrier Oil" },
    { name: "Rose Wood Oil", type: "Carrier Oil" },
    { name: "Spike Lavender Oil", type: "Carrier Oil" },
    { name: "Cucumber Oil", type: "Carrier Oil" },
    { name: "Custard Apple Seed Oil", type: "Carrier Oil" },
    { name: "Corn Oil", type: "Carrier Oil" },
    { name: "Evening Primrose Oil", type: "Carrier Oil" },
    { name: "Extra Virgin Olive Oil", type: "Carrier Oil" },
    { name: "Flax Seed Oil", type: "Carrier Oil" },
    { name: "Grapeseed Oil", type: "Carrier Oil" },
    { name: "Hazel Nut Oil", type: "Carrier Oil" },
    { name: "Hemp Seed Oil", type: "Carrier Oil" },
    { name: "Jojoba Oil (colourless)", type: "Carrier Oil" },
    { name: "Jojoba Oil (golden)", type: "Carrier Oil" },
    { name: "Karanj Oil", type: "Carrier Oil" },
    { name: "Laurel Berry Oil", type: "Carrier Oil" },
    { name: "Linseed Oil", type: "Carrier Oil" },
    { name: "Moringa Oil", type: "Carrier Oil" },
    { name: "Musk Melon Oil", type: "Carrier Oil" },
    { name: "Sage Oil", type: "Carrier Oil" },
    { name: "Tuberose Oil", type: "Carrier Oil" },
    { name: "Tarragon Oil", type: "Carrier Oil" },
    { name: "Vertiver Oil", type: "Carrier Oil" },
    { name: "Wintergreen Oil", type: "Carrier Oil" },
    { name: "Ylang Ylang Oil", type: "Carrier Oil" },
    { name: "Neem Oil", type: "Carrier Oil" },
    { name: "Olive Oil Pomace", type: "Carrier Oil" },
    { name: "Papaya Seed Oil", type: "Carrier Oil" },
    { name: "Peach Kernel Oil", type: "Carrier Oil" },
    { name: "Pomegranate Oil", type: "Carrier Oil" },
    { name: "Pumpkin Seed Oil", type: "Carrier Oil" },
    { name: "Rose Hip Seed Oil", type: "Carrier Oil" },
    { name: "Safflower Oil", type: "Carrier Oil" },
    { name: "Sawpalmetto Oil", type: "Carrier Oil" },
    { name: "Soybean Oil", type: "Carrier Oil" },
    { name: "Seabuckthorn Oil", type: "Carrier Oil" },
    { name: "Sesame Seed Oil", type: "Carrier Oil" },
    { name: "Virgin Olive Oil", type: "Carrier Oil" },
    { name: "Walnut Oil", type: "Carrier Oil" },
    { name: "Watermelon Seed Oil", type: "Carrier Oil" },
    { name: "Wheat Germ Oil", type: "Carrier Oil" },
    { name: "Armoise Oil", type: "Carrier Oil" },
    { name: "Angelica Root Oil", type: "Carrier Oil" },
    { name: "Bay Oil", type: "Carrier Oil" },
    { name: "Bergamot Oil", type: "Carrier Oil" },
    { name: "Citronella Oil", type: "Carrier Oil" },
    { name: "Clary Sage Oil", type: "Carrier Oil" },
    { name: "Cyprus Oil", type: "Carrier Oil" },
    { name: "Galangal Oil", type: "Carrier Oil" }
  ];

   const extracts = [
    { name: "Astaxanthin", specification: "N/A" },
    { name: "Lutein", specification: "N/A" },
    { name: "Lycopene", specification: "N/A" },
    { name: "Acai Berry Extract", specification: "N/A" },
    { name: "Pomegranate Extract", specification: "N/A" },
    { name: "Bilberry Extract", specification: "N/A" },
    { name: "Pine Bark Extract", specification: "N/A" },
    { name: "Resveratrol", specification: "N/A" },
    { name: "Green Tea Extract", specification: "N/A" },
    { name: "Acerola Cherry Extract", specification: "N/A" },
    { name: "Phyllanthus Emblica Extract", specification: "N/A" },
    { name: "Mangosteen Extract", specification: "N/A" },
    { name: "Grape Seed Extract", specification: "N/A" },
    { name: "Soybean Extract", specification: "N/A" },
    { name: "Black Cohosh Extract", specification: "N/A" },
    { name: "Wild Yam Extract", specification: "N/A" },
    { name: "Chrysanthemum Extract", specification: "N/A" },
    { name: "Baical Skullcap Root Extract", specification: "N/A" },
    { name: "Angelica/Dong Quai Extract", specification: "N/A" },
    { name: "Kudzu Root (Puerara) Extract", specification: "N/A" },
    { name: "Avocado Soy", specification: "20%, 40%" },
    { name: "Lycopene", specification: "2%, 2.5%" },
    { name: "Pomegranate Extract", specification: "8%, 16%, 98%" },
    { name: "Grape Seed Extract", specification: "15:1, 10:1" },
    { name: "Soybean Extract", specification: "85%" },
    { name: "Black Cohosh Extract", specification: "10:1, 1%" },
    { name: "Green Tea Extract", specification: "40%, 80%" },
    { name: "Mangosteen Extract", specification: "30%-40%" },
    { name: "Soybean Extract", specification: "3%, 5%" },
    { name: "Pomegranate Extract", specification: "5%, 10%, 20%" },
    { name: "Grape Seed Extract", specification: "5%, 6%, 10%" },
    { name: "Baical Skullcap Root Extract", specification: "10:1" },
    { name: "Chrysanthemum Extract", specification: "40%" },
    { name: "Soybean Extract", specification: "25%, 36%" },
    { name: "Black Cohosh Extract", specification: "30%-98%" },
    { name: "Green Tea Extract", specification: "10%, 20%, 50%, 98%" },
    { name: "Acai Berry Extract", specification: "50%, 95%, 98%" },
    { name: "Pomegranate Extract", specification: "17%, 25%" },
    { name: "Lycopene", specification: "10:1" },
    { name: "Black Cohosh Extract", specification: "10%, 20%, 30%, 95%" },
    { name: "Grape Seed Extract", specification: "95% OPC, 80%-95% Polyphenol" },
    { name: "Gymnema Extract", specification: "25%" },
    { name: "Bitter Melon Extract", specification: "10%" },
    { name: "Dogbane Leaf Extract", specification: "10:1" },
    { name: "Artichoke Extract", specification: "2.5%, 5%" },
    { name: "Mulberry Leaf Extract", specification: "DNJ 1%" },
    { name: "Tartary Buckwheat Extract", specification: "10:1" },
    { name: "Celery Seed Extract", specification: "1%, 10:1, 5:1" },
    { name: "Pomegranate Extract", specification: "40% Polyphenol" },
    { name: "Garlic Extract", specification: "Allicin 1%, Alliin 2%, 5%" },
    { name: "Corn Silk Extract", specification: "Beta sitosterol 5%, 10:1" },
    { name: "Salvia Miltiorrhiza Extract", specification: "10:1, 10%, 20%" },
    { name: "Red Yeast Rice Extract", specification: "0.1%, 0.3%, 0.8%, 1%" },
    { name: "Corosolic Acid", specification: "1%, 2%, 5%, 10%, 20%, 98%" },
    { name: "Ginkgo Biloba Extract", specification: "CP2005, CP2010, USP32" },
    { name: "Raspberry Ketone Extract", specification: "99%" },
    { name: "Senna Extract", specification: "6%-20%" },
    { name: "Hawthorn Extract", specification: "5%-30%" },
    { name: "Lotus Leaf Extract", specification: "10:1, 1%, 2%" },
    { name: "Green Tea Extract", specification: "50%, 95%, 98%" },
    { name: "Garcinia Cambogia Extract", specification: "50%, 60%" },
    { name: "White Kidney Bean Extract", specification: "10:1, 1%, 2%" },
    { name: "Irvingia Gabonensis Extract", specification: "10:1, 20:1" },
    { name: "Green Coffee Bean Extract", specification: "50%, 60%, 98%" },
    { name: "5-HTP/Griffonia Seed Extract", specification: "20%-90%" },
    { name: "CoQ10", specification: "N/A" },
    { name: "Huperzine A", specification: "N/A" },
    { name: "Rhodiola Rosea Extract", specification: "N/A" },
    { name: "Panax Ginseng Extract", specification: "N/A" },
    { name: "Valerian Root Extract", specification: "N/A" },
    { name: "Horse Chestnut Extract", specification: "N/A" },
    { name: "Lemon Balm Extract", specification: "N/A" },
    { name: "Gastrodia Tuber Extract", specification: "N/A" },
    { name: "Galanthamine Hydrobromide", specification: "N/A" },
    { name: "Passion Flower Extract", specification: "N/A" },
    { name: "Siberian Ginseng Extract", specification: "N/A" },
    { name: "Semen Ziziphi Spinosae Extract", specification: "N/A" },
    { name: "Butcher’s Broom Extract", specification: "N/A" },
    { name: "Yarrow Extract", specification: "N/A" },
    { name: "Juniper Berry", specification: "N/A" },
    { name: "HoneySuckle Flower Extract", specification: "N/A" },
    { name: "Rosemary Extract", specification: "N/A" },
    { name: "Holy basil extract", specification: "N/A" },
    { name: "Folium Perillae Extract", specification: "N/A" },
    { name: "Aloe Vera Gel Freeze Dried Powder", specification: "N/A" },
    { name: "Witch Hazel Extract", specification: "N/A" },
    { name: "Peppermint Extract", specification: "N/A" },
    { name: "Bearberry Extract", specification: "N/A" },
    { name: "Rose Extract", specification: "N/A" },
  ];

  const healthIngredients = [
    { ingredient: "Cow Colostrum Powder", botanicalName: "", partUsed: "" },
    { ingredient: "Psyllium Husk", botanicalName: "", partUsed: "" },
    { ingredient: "Spirullina", botanicalName: "", partUsed: "" },
    { ingredient: "Energy Brow (Safed Musli + Ashwagandha) Sugar Free", botanicalName: "", partUsed: "" },
    { ingredient: "Noni Juice", botanicalName: "", partUsed: "" },
    { ingredient: "Wheatgrass Powder", botanicalName: "Triticum aestivum", partUsed: "Grass" },
    { ingredient: "Barley Grass Powder", botanicalName: "Hordeum vulgare", partUsed: "Grass" },
    { ingredient: "Moringa Leaf Powder", botanicalName: "Moringa oleifera", partUsed: "Leaf" },
    { ingredient: "Beetroot Powder", botanicalName: "Beta vulgaris", partUsed: "Root" },
    { ingredient: "Amla Powder", botanicalName: "Phyllanthus emblica", partUsed: "Fruit" },
    { ingredient: "Ginger Powder", botanicalName: "Zingiber officinale", partUsed: "Root" },
    { ingredient: "Turmeric Powder", botanicalName: "Curcuma longa", partUsed: "Rhizome" },
    { ingredient: "Ashwagandha Powder", botanicalName: "Withania somnifera", partUsed: "Root" },
    { ingredient: "Safed Musli Powder", botanicalName: "Chlorophytum borivilianum", partUsed: "Root" },
    { ingredient: "Shatavari Powder", botanicalName: "Asparagus racemosus", partUsed: "Root" },
    { ingredient: "Gokshura Powder", botanicalName: "Tribulus terrestris", partUsed: "Fruit" },
    { ingredient: "Giloy Powder", botanicalName: "Tinospora cordifolia", partUsed: "Stem" },
    { ingredient: "Green Tea Extract", botanicalName: "Camellia sinensis", partUsed: "Leaf" },
    { ingredient: "Flaxseed Powder", botanicalName: "Linum usitatissimum", partUsed: "Seed" },
  ];

const grainsAndPulses = [
  { ingredient: "Batri Dall", hindiName: "BATRI DAL", botanicalName: "", partUsed: "" },

  { ingredient: "Matpe Beans (Urad)", hindiName: "URAD", botanicalName: "Vigna mungo", partUsed: "Seed" },

  { ingredient: "Brown Eye Bean", hindiName: "CHAWLA", botanicalName: "", partUsed: "" },

  { ingredient: "Chickpeas (Kabuli)", hindiName: "KABULI CHANA", botanicalName: "Cicer arietinum", partUsed: "Seed" },

  { ingredient: "Split Chickpeas", hindiName: "CHANA DAL", botanicalName: "Cicer arietinum", partUsed: "Seed" },

  { ingredient: "Desi Chickpeas", hindiName: "CHANA", botanicalName: "Cicer arietinum", partUsed: "Seed" },

  { ingredient: "Green Peas", hindiName: "GREEN MATAR", botanicalName: "Pisum sativum", partUsed: "Seed" },

  { ingredient: "Kidney Beans", hindiName: "RAJMA CHITRA", botanicalName: "Phaseolus vulgaris", partUsed: "Seed" },

  { ingredient: "Moong Beans", hindiName: "MOONG", botanicalName: "Vigna radiata", partUsed: "Seed" },

  { ingredient: "Moong Split", hindiName: "MOONG DAL WITH SKIN", botanicalName: "Vigna radiata", partUsed: "Seed" },

  { ingredient: "Moong Split", hindiName: "MOONG MOGAR WITHOUT SKIN", botanicalName: "Vigna radiata", partUsed: "Seed" },

  { ingredient: "Moth Beans", hindiName: "MOTH", botanicalName: "Vigna aconitifolia", partUsed: "Seed" },

  { ingredient: "Split Pigeon Peas", hindiName: "TUR DAL", botanicalName: "Cajanus cajan", partUsed: "Seed" },

  { ingredient: "Red Kidney Beans", hindiName: "LAL RAJMA", botanicalName: "Phaseolus vulgaris", partUsed: "Seed" },

  { ingredient: "Red Lentil", hindiName: "MASUR", botanicalName: "Lens culinaris", partUsed: "Seed" },

  { ingredient: "Red Split Lentils", hindiName: "MASUR DAL", botanicalName: "Lens culinaris", partUsed: "Seed" },

  { ingredient: "Urad Split (With Skin)", hindiName: "URAD DAL", botanicalName: "Vigna mungo", partUsed: "Seed" },

  { ingredient: "Urad Split (Without Skin)", hindiName: "URAD MOGAR", botanicalName: "Vigna mungo", partUsed: "Seed" },

  { ingredient: "Urad Whole Without Skin", hindiName: "URAD GOTA", botanicalName: "Vigna mungo", partUsed: "Seed" },

  { ingredient: "Yellow Peas Split", hindiName: "MATAR DAL", botanicalName: "Pisum sativum", partUsed: "Seed" },

  { ingredient: "Yellow Peas", hindiName: "MATAR", botanicalName: "Pisum sativum", partUsed: "Seed" },
];





  const filterData = herbsData.filter((item) =>
    Object.values(item).some((val) => val.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const ingredData = healthIngredients.filter((item) =>
    Object.values(item).some((val) => val.toLowerCase().includes(ingredSearch.toLowerCase()))
  );

  const filteredOils = oils.filter((item) =>
    Object.values(item).some((val) => val.toLowerCase().includes(oilSearch.toLowerCase()))
  );

  const filteredExtracts = extracts.filter((item) =>
    Object.values(item).some((val) => val.toLowerCase().includes(extractSearch.toLowerCase()))
  );

  const filterPulses= grainsAndPulses.filter((item)=> Object.values(item).some((val) => val.toLowerCase().includes(pulseSearch.toLowerCase())))

  // Convert herbs data to flat array
  const flatHerbsData = filterData.flatMap(item => [
    { name: item.herb1, botanical: item.botanical1 },
    { name: item.herb2, botanical: item.botanical2 }
  ]);

  return (
    <>
      <style>{`
        /* Banner */
        .product-banner {
        padding:7%;
          background-size: cover;
          background-position: bottom;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .product-banner-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(0, 0, 0, 0.7), rgba(236, 72, 153, 0.4));
        }

        .product-banner-title {
          position: relative;
          color: white;
          margin-top:75px;
          font-size: 4rem;
          font-weight: 700;
          text-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
          z-index: 1;
        }

        /* Main Section */
        .products-main-section {
          background: linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%);
          padding: 5rem 0;
        }

        .product-section-wrapper {
          margin-bottom: 6rem;
        }

        /* Section Header */
        .section-header-box {
          text-align: center;
          margin-bottom: 3rem;
        }

        .section-title-main {
          font-size: 2.8rem;
          font-weight: 700;
          margin-bottom: 1rem;
          position: relative;
          display: inline-block;
          color: blue;
        }

        .section-subtitle {
          color: #6c757d;
          font-size: 1.1rem;
          max-width: 600px;
          margin: 0 auto;
        }

        /* Search and Filter Bar */
        .search-filter-bar {
          background: white;
          border-radius: 24px;
          padding: 2rem;
          margin-bottom: 3rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          display: flex;
          gap: 1.5rem;
          align-items: center;
          flex-wrap: wrap;
        }

        .search-box {
          flex: 1;
          min-width: 250px;
          position: relative;
        }

        .search-input-modern {
          width: 100%;
          padding: 1rem 1rem 1rem 3rem;
          border: 2px solid #e9ecef;
          border-radius: 16px;
          font-size: 1rem;
          transition: all 0.3s ease;
        }

        .search-input-modern:focus {
          outline: none;
          border-color: #0d6efd;
          box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.1);
        }

        .search-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          font-size: 1.2rem;
          color: #adb5bd;
        }

        /* Product Grid */
        .product-grid {
          display: grid;
          height: 100%;
          max-height:500px;
          overflow-y:scroll;
          padding: 18px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 10px;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 1rem;
        }

        .product-card {
          background: white;
          border-radius: 12px;
          padding: 1rem 1.25rem;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          border-left: 4px solid transparent;
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .product-card:hover {
          transform: translateX(5px);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
        }

        .card-pink {
          border-left-color: #3b82f6;
        }

        .card-pink:hover {
          background: linear-gradient(90deg, rgba(236, 72, 153, 0.03), white);
        }

        .card-green {
          border-left-color: #4ade80;
        }

        .card-green:hover {
          background: linear-gradient(90deg, rgba(74, 222, 128, 0.03), white);
        }

        .card-orange {
          border-left-color: #fbbf24;
        }

        .card-orange:hover {
          background: linear-gradient(90deg, rgba(251, 191, 36, 0.03), white);
        }

        .card-blue {
          border-left-color: #3b82f6;
        }

        .card-blue:hover {
          background: linear-gradient(90deg, rgba(59, 130, 246, 0.03), white);
        }

        .product-icon {
          width: 45px;
          height: 45px;
          min-width: 45px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          position: relative;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .icon-pink {
          background: linear-gradient(135deg, #ec4899, #9333ea);
        }

        .icon-green {
          background: linear-gradient(135deg, #4ade80, #0d9488);
        }

        .icon-orange {
          background: linear-gradient(135deg, #fbbf24, #f97316);
        }

        .icon-blue {
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
        }

        .product-content {
          flex: 1;
          min-width: 0;
        }

        .product-card-title {
          font-size: 0.95rem;
          font-weight: 600;
          color: #212529;
          margin-bottom: 0.25rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .product-card-subtitle {
          font-size: 0.8rem;
          color: #6c757d;
          margin-bottom: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .product-badge {
          padding: 0.25rem 0.6rem;
          border-radius: 6px;
          font-size: 0.65rem;
          font-weight: 600;
          color: white;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          white-space: nowrap;
          flex-shrink: 0;
        }

        .badge-pink {
         background:#3b82f6;
        }

        .badge-green {
          background: linear-gradient(135deg, #4ade80, #0d9488);
        }

        .badge-orange {
          background: linear-gradient(135deg, #fbbf24, #f97316);
        }

        .badge-blue {
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
        }

        /* Featured Image Section */
        .featured-section {
          background: white;
          border-radius: 32px;
          padding: 3rem;
          margin-bottom: 3rem;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
          position: relative;
          overflow: hidden;
        }

        .featured-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 3rem;
          align-items: center;
        }

        .featured-image {
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
        }

        .featured-image img {
          width: 100%;
          height: 400px;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .featured-image:hover img {
          transform: scale(1.1);
        }

        .featured-text h3 {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
         color: black;
        }

        .featured-text p {
          font-size: 1.1rem;
          color: #6c757d;
          line-height: 1.8;
        }

        /* Stats Box */
        .stats-box {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.5rem;
          margin-top: 2rem;
        }

        .stat-item {
          text-align: center;
          padding: 1.5rem;
          border-radius: 16px;
          background: #f8f9fa;
        }

        .stat-number {
          font-size: 2rem;
          font-weight: 700;
          background: linear-gradient(135deg, #0d6efd, #6610f2);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .stat-label {
          font-size: 0.9rem;
          color: #6c757d;
          margin-top: 0.5rem;
        }

        /* Empty State */
        .empty-state {
          text-align: center;
          padding: 4rem 2rem;
          color: #6c757d;
        }

        .empty-state-icon {
          font-size: 4rem;
          margin-bottom: 1rem;
          opacity: 0.3;
        }

        /* Responsive */
        @media (max-width: 1199px) {
          .product-grid {
            grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
          }

          .featured-content {
            gap: 2rem;
          }
        }

        @media (max-width: 991px) {
          .products-main-section {
            padding: 4rem 0;
          }

          .section-title-main {
            font-size: 2.3rem;
          }

          .product-grid {
            grid-template-columns: 1fr;
          }

          .featured-section {
            padding: 2rem;
          }

          .featured-content {
            grid-template-columns: 1fr;
            gap: 2rem;
          }

          .featured-image img {
            height: 350px;
          }

          .stats-box {
            grid-template-columns: repeat(3, 1fr);
            gap: 1rem;
          }
        }

        @media (max-width: 767px) {
          .product-banner {
            height: 450px;
          }

          .product-banner-title {
            font-size: 2.5rem;
            padding: 0 1rem;
          }

          .products-main-section {
            padding: 3rem 0;
          }

          .section-title-main {
            font-size: 2rem;
          }

          .search-filter-bar {
            padding: 1.5rem;
            gap: 1rem;
          }

          .search-box {
            min-width: 100%;
          }

          .product-card {
            padding: 0.9rem 1rem;
          }

          .product-icon {
            width: 40px;
            height: 40px;
            min-width: 40px;
            font-size: 1.3rem;
          }

          .product-card-title {
            font-size: 0.9rem;
          }

          .product-card-subtitle {
            font-size: 0.75rem;
          }

          .product-badge {
            padding: 0.2rem 0.5rem;
            font-size: 0.6rem;
          }

          .featured-section {
            padding: 1.5rem;
            border-radius: 24px;
          }

          .featured-text h3 {
            font-size: 2rem;
          }

          .featured-image img {
            height: 300px;
          }

          .stats-box {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 575px) {
          .product-banner {
            height: 350px;
          }

          .product-banner-title {
            font-size: 2rem;
          }

          .section-title-main {
            font-size: 1.75rem;
          }

          .section-subtitle {
            font-size: 1rem;
          }

          .product-card {
            padding: 0.8rem;
          }

          .product-icon {
            width: 38px;
            height: 38px;
            min-width: 38px;
            font-size: 1.2rem;
          }

          .product-card-title {
            font-size: 0.85rem;
          }
       
          .product-card-subtitle {
            font-size: 0.7rem;
          }

          .featured-text h3 {
            font-size: 1.75rem;
          }

          .featured-text p {
            font-size: 1rem;
          }

          .stat-number {
            font-size: 1.5rem;
          }
        }
      `}</style>

      {/* Banner */}
      <div
        className="product-banner"
        style={{
          backgroundImage: `url(${require('../assets/images/ProductBanner1.jpeg')})`,
        }}
      >
        <div className="product-banner-overlay"></div>
        <h1 className="product-banner-title">Our Products</h1>
      </div>

      {/* Main Products Section */}
      <section className="products-main-section">
        <div className="container">
          
          {/* Herbs Section */}
          <div className="product-section-wrapper">
            <div className="section-header-box">
              <h2 className="section-title-main" >
                🌿 Herbs In Crude, Powder & Extracts
              </h2>
              <p className="section-subtitle">
                Premium quality herbs sourced from the finest regions worldwide
              </p>
            </div>

            <div className="featured-section">
              <div className="featured-content">
                <div className="featured-image">
                  <img src={require('../assets/images/herbsimage.png')} alt="Herbs" />
                </div>
                <div className="featured-text">
                  <h3>Natural Herbal Excellence</h3>
                  <p>
                    Discover our extensive collection of authentic herbs available in crude, powder, and extract forms. Each product is carefully sourced and processed to maintain maximum potency and purity.
                  </p>
                  <div className="stats-box">
                    <div className="stat-item">
                      <div className="stat-number">{flatHerbsData.length}+</div>
                      <div className="stat-label">Varieties</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number">100%</div>
                      <div className="stat-label">Natural</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number">Pure</div>
                      <div className="stat-label">Quality</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="search-filter-bar">
              <div className="search-box">
                <span className="search-icon">🔍</span>
                <input
                  type="text"
                  className="search-input-modern"
                  placeholder="Search herbs or botanical names..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="product-grid">
              {flatHerbsData.length > 0 ? (
                flatHerbsData.map((item, index) => (
                  <div key={index} className="product-card card-pink">
                    <div className="product-content">
                      <h4 className="product-card-title">{item.name}</h4>
                      <p className="product-card-subtitle">{item.botanical}</p>
                    </div>
                    <div className="product-badge badge-pink">Herb</div>
                  </div>
                ))
              ) : (
                <div className="empty-state" style={{ gridColumn: '1 / -1' }}>
                  <div className="empty-state-icon">🔍</div>
                  <p>No herbs found matching your search</p>
                </div>
              )}
            </div>
          </div>

          {/* Health Ingredients Section */}
          <div className="product-section-wrapper">
            <div className="section-header-box">
              <h2 className="section-title-main" style={{ background: 'linear-gradient(135deg, #4ade80, #0d9488)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                💚 Health Ingredients
              </h2>
              <p className="section-subtitle">
                Essential ingredients for optimal health and wellness
              </p>
            </div>

            <div className="featured-section">
              <div className="featured-content">
                <div className="featured-text">
                  <h3>Wellness Boosters</h3>
                  <p>
                    Our health ingredients are specially selected to support your wellness journey. From superfoods to traditional remedies, each ingredient is tested for quality and efficacy.
                  </p>
                  <div className="stats-box">
                    <div className="stat-item">
                      <div className="stat-number">{healthIngredients.length}+</div>
                      <div className="stat-label">Products</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number">Organic</div>
                      <div className="stat-label">Certified</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number">Fresh</div>
                      <div className="stat-label">Quality</div>
                    </div>
                  </div>
                </div>
                <div className="featured-image">
                  <img src={require('../assets/images/ingradients.png')} alt="Health Ingredients" />
                </div>
              </div>
            </div>

            <div className="search-filter-bar">
              <div className="search-box">
                <span className="search-icon">🔍</span>
                <input
                  type="text"
                  className="search-input-modern"
                  placeholder="Search health ingredients..."
                  value={ingredSearch}
                  onChange={(e) => setingredSearch(e.target.value)}
                />
              </div>
            </div>

            <div className="product-grid">
              {ingredData.length > 0 ? (
                ingredData.map((item, index) => (
                  <div key={index} className="product-card card-green">
                    <div className="product-content">
                      <h4 className="product-card-title">{item.ingredient}</h4>
                      <p className="product-card-subtitle">
                        {item.botanicalName || item.partUsed || 'Premium Quality'}
                      </p>
                    </div>
                    <div className="product-badge badge-green">Wellness</div>
                  </div>
                ))
              ) : (
                <div className="empty-state" style={{ gridColumn: '1 / -1' }}>
                  <div className="empty-state-icon">🔍</div>
                  <p>No ingredients found matching your search</p>
                </div>
              )}
            </div>
          </div>

          {/* Essential Oils Section */}
          <div className="product-section-wrapper">
            <div className="section-header-box">
              <h2 className="section-title-main" style={{ background: 'linear-gradient(135deg, #fbbf24, #f97316)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                💧 Herbal Essential Oils
              </h2>
              <p className="section-subtitle">
                Pure and therapeutic grade essential oils from nature
              </p>
            </div>

            <div className="featured-section">
              <div className="featured-content">
                <div className="featured-image">
                  <img src={require('../assets/images/oilproduct.png')} alt="Essential Oils" />
                </div>
                <div className="featured-text">
                  <h3 style={{ background: 'linear-gradient(135deg, #fbbf24, #f97316)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Aromatic Purity</h3>
                  <p>
                    Experience the healing power of nature with our collection of essential and carrier oils. Each oil is steam-distilled or cold-pressed to preserve its natural therapeutic properties.
                  </p>
                  <div className="stats-box">
                    <div className="stat-item">
                      <div className="stat-number">{oils.length}+</div>
                      <div className="stat-label">Oil Types</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number">Pure</div>
                      <div className="stat-label">Grade</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number">Natural</div>
                      <div className="stat-label">Extraction</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="search-filter-bar">
              <div className="search-box">
                <span className="search-icon">🔍</span>
                <input
                  type="text"
                  className="search-input-modern"
                  placeholder="Search essential oils..."
                  value={oilSearch}
                  onChange={(e) => setOilSearch(e.target.value)}
                />
              </div>
            </div>

            <div className="product-grid">
              {filteredOils.length > 0 ? (
                filteredOils.map((item, index) => (
                  <div key={index} className="product-card card-orange">
                    <div className="product-content">
                      <h4 className="product-card-title">{item.name}</h4>
                      <p className="product-card-subtitle">Therapeutic Grade</p>
                    </div>
                    <div className="product-badge badge-orange">{item.type}</div>
                  </div>
                ))
              ) : (
                <div className="empty-state" style={{ gridColumn: '1 / -1' }}>
                  <div className="empty-state-icon">🔍</div>
                  <p>No oils found matching your search</p>
                </div>
              )}
            </div>
          </div>

          {/* Botanical Extracts Section */}
          <div className="product-section-wrapper">
            <div className="section-header-box">
              <h2 className="section-title-main" style={{ background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                ⚗️ Herbal Botanical Extracts
              </h2>
              <p className="section-subtitle">
                Concentrated botanical extracts for maximum potency
              </p>
            </div>

            <div className="featured-section">
              <div className="featured-content">
                <div className="featured-text">
                  <h3 style={{ background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Potent Formulations</h3>
                  <p>
                    Our botanical extracts are standardized and concentrated to ensure consistent quality and effectiveness. Perfect for supplements, cosmetics, and therapeutic applications.
                  </p>
                  <div className="stats-box">
                    <div className="stat-item">
                      <div className="stat-number">{extracts.length}+</div>
                      <div className="stat-label">Extracts</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number">Lab</div>
                      <div className="stat-label">Tested</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number">High</div>
                      <div className="stat-label">Potency</div>
                    </div>
                  </div>
                </div>
                <div className="featured-image">
                  <img src={require('../assets/images/extractoil.png')} alt="Botanical Extracts" />
                </div>
              </div>
            </div>

            <div className="search-filter-bar">
              <div className="search-box">
                <span className="search-icon">🔍</span>
                <input
                  type="text"
                  className="search-input-modern"
                  placeholder="Search botanical extracts..."
                  value={extractSearch}
                  onChange={(e) => setExtractSearch(e.target.value)}
                />
              </div>
            </div>

            <div className="product-grid">
              {filteredExtracts.length > 0 ? (
                filteredExtracts.map((item, index) => (
                  <div key={index} className="product-card card-blue">
                    <div className="product-content">
                      <h4 className="product-card-title">{item.name}</h4>
                      <p className="product-card-subtitle">Standardized Extract</p>
                    </div>
                    <div className="product-badge badge-blue">{item.specification}</div>
                  </div>
                ))
              ) : (
                <div className="empty-state" style={{ gridColumn: '1 / -1' }}>
                  <div className="empty-state-icon">🔍</div>
                  <p>No extracts found matching your search</p>
                </div>
              )}
            </div>
          </div>
          {/* Pulses and Grains Section */}
           <div className="product-section-wrapper">
  <div className="section-header-box">
    <h2
      className="section-title-main"
      style={{
        background: 'linear-gradient(135deg, #22c55e, #16a34a)', // Green gradient
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }}
    >
      🌾 Pulses & Grains
    </h2>
    <p className="section-subtitle">
      High-quality pulses and grains sourced from trusted farms for global supply.
    </p>
  </div>

  <div className="featured-section">
    <div className="featured-content">
       <div className="featured-image">
        <img
          src={require('../assets/images/banner5.jpg')}
          alt="Pulses and Grains"
        />
      </div>
      <div className="featured-text">
        <h3
          style={{
            background: 'linear-gradient(135deg, #22c55e, #16a34a)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Wholesome & Nutritious
        </h3>
        <p>
          Our pulses and grains are carefully selected for their superior taste, nutrition, and
          purity. Ideal for exports, retail packaging, and bulk trade.
        </p>

        <div className="stats-box">
          <div className="stat-item">
            <div className="stat-number">{grainsAndPulses.length}+</div>
            <div className="stat-label">Varieties</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">Farm</div>
            <div className="stat-label">Fresh</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">Globally</div>
            <div className="stat-label">Sourced</div>
          </div>
        </div>
      </div> 
    </div>
  </div>

  <div className="search-filter-bar">
    <div className="search-box">
      <span className="search-icon">🔍</span>
      <input
        type="text"
        className="search-input-modern"
        placeholder="Search pulses or grains..."
        value={pulseSearch}
        onChange={(e) => setPulseSearch(e.target.value)}
      />
    </div>
  </div>

  <div className="product-grid">
    {filterPulses.length > 0 ? (
      filterPulses.map((item, index) => (
        <div key={index} className="product-card card-green">
          <div className="product-content">
            <h4 className="product-card-title">{item.ingredient}</h4>
            <td style={{color:"black"}}>{item.hindiName || '-'}</td>
            {item.botanicalName && (
              <p className="product-card-subtitle">
                <em>{item.botanicalName}</em>
                 <td>{item.partUsed || '-'}</td>
              </p>
            )}
          </div>
          {item.partUsed && (
            <div className="product-badge badge-green">{item.partUsed}</div>
          )}
        </div>
      ))
    ) : (
      <div className="empty-state" style={{ gridColumn: '1 / -1' }}>
        <div className="empty-state-icon">🔍</div>
        <p>No pulses or grains found</p>
      </div>
    )}
  </div>
</div>
        </div>
      </section>
    </>
  );
};

export default Products;